import { ALL_BUTTON_POSITION_LIST } from '@/common/manager/position/button-position';
import { calculateTextExprValue, isArrayNotEmpty } from '@/common/util/util';
export const config = {
    value: 'setTableSelectRowKeys',
    position: ALL_BUTTON_POSITION_LIST,
    action: (config) => {
        const { buttonConfig, _context, state, urlParamsDataSource } = config || {};
        const { options } = buttonConfig || {};
        const { _bindTable, selectedRowKeys } = options || {};
        function selectOneTable(id, keys) {
            if (typeof id === 'string') {
                const table = _context.$(id);
                if (table) {
                    const innerInfo = table.getRemoteOperation?.()?.current?.innerInfo;
                    if (innerInfo) {
                        innerInfo?.setSelectKeys(keys);
                    }
                }
            }
        }
        if (isArrayNotEmpty(_bindTable) && _context && selectedRowKeys) {
            const realSelectedRowKeys = calculateTextExprValue(selectedRowKeys, {
                urlParamsDataSource,
                recordDataSource: {},
                state,
            });
            if (Array.isArray(realSelectedRowKeys)) {
                _bindTable.forEach((item) => {
                    selectOneTable(item, realSelectedRowKeys);
                });
            }
        }
    },
};
